import React, { FunctionComponent } from "react";
import styles from "./Hero.module.scss";
import HeroContent from "./HeroContent.model";

import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";

const Hero: FunctionComponent<HeroContent> = (props) => {
    const processedHeadline = getProcessedRichtext(formatDynamicTextColor(props.content.headline));
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Tagline */}
                {props.content.tagline ?
                    <span className={styles.tagline}>{props.content.tagline}</span>
                    : null}

                {/* Headline */}
                {props.content.headline ?
                    <DynamicHeading className={styles.headline} headlineSize={props.content.headlineSize} headlineWeight={props.content.headlineWeight} innerHtml={processedHeadline}></DynamicHeading>
                    : null}

                {/* Introductory */}
                {props.content.introductory ?
                    <p className={styles.introductory}>{props.content.introductory}</p>
                    : null}

                {/* Body Text */}
                {processedBodyText ?
                    <div className={styles.bodyText} dangerouslySetInnerHTML={processedBodyText}></div>
                    : null}

                {/* Buttons */}
                {props.content.buttons && props.content.buttons.length > 0 ?
                    <div className={styles.buttons}>
                        {props.content.buttons.map(button => {
                            return (
                                <Anchor key={button.contentUdi} to={button?.link} target={button?.target} className={styles.button}>
                                    <span className={styles.button_label}>{button?.label}</span>
                                </Anchor>
                            );
                        })}
                    </div> : null}
            </div>
        </div>
    );
};

export default Hero;